module.exports = __webpack_public_path__ + "static/media/aces_s2_off.73ff3650.svg";